export function hasPermission(access, permissionCode) {
  return (access?.permissions || []).some((p) => p.code === permissionCode);
}

export function hasModule(access, moduleCode) {
  return (access?.visible_modules || []).includes(moduleCode);
}

export function getScope(access, moduleCode) {
  return (access?.scopes || []).find((s) => s.module_code === moduleCode)?.scope || "none";
}